import { render, staticRenderFns } from "./terms&condition.vue?vue&type=template&id=81ec911e&scoped=true"
var script = {}
import style0 from "./terms&condition.vue?vue&type=style&index=0&id=81ec911e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ec911e",
  null
  
)

export default component.exports